import { __awaiter } from "tslib";
import { useState } from 'react';
import { useAuthenticateMutation } from '@websky/graphql';
import { PixelMessageBuilder } from '@websky/pixel';
import { sendPixelEvent } from '@shared/lib/pixel/sendPixelEvent';
const sendAuthDetectedPixelEvent = (authParams, externalId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!authParams || !externalId) {
        return;
    }
    yield sendPixelEvent(cdpId => PixelMessageBuilder.buildAuthDetectedEvent(authParams, cdpId, externalId));
    yield new Promise(resolve => setTimeout(resolve, 1000)); // таймаут на отправку события
});
/**
 * Обёртка над useAuthenticateMutation, которая позволяет встроить кастомные действия
 * между получением ответа мутации и возвратом результата.
 *
 * Полностью обратно совместима с исходным API useAuthenticateMutation.
 */
export const useAuthenticate = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [originalMutate, otherResults] = useAuthenticateMutation();
    const wrappedMutate = (options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        setIsLoading(true);
        try {
            const result = yield originalMutate(options);
            if ((!result.errors || result.errors.length === 0) && ((_a = result.data) === null || _a === void 0 ? void 0 : _a.Authenticate)) {
                yield sendAuthDetectedPixelEvent((_b = options === null || options === void 0 ? void 0 : options.variables) === null || _b === void 0 ? void 0 : _b.params, (_c = result.data.Authenticate.user) === null || _c === void 0 ? void 0 : _c.userId);
            }
            return result;
        }
        catch (error) {
            throw error;
        }
        finally {
            setIsLoading(false);
        }
    });
    return [wrappedMutate, Object.assign(Object.assign({}, otherResults), { loading: otherResults.loading || isLoading })];
};
